var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-text-field", {
        staticClass: "new-monitoring-point__name",
        attrs: {
          required: "",
          autofocus: "",
          dense: "",
          label: _vm.$t("field.name_label"),
          hint: _vm.$t("msg.hint_name"),
          rules: _vm.nameRules,
          "persistent-hint": "",
          "data-testid": "new-monitoring-point-name",
        },
        model: {
          value: _vm.name,
          callback: function ($$v) {
            _vm.name = $$v
          },
          expression: "name",
        },
      }),
      _vm._v(" "),
      _c("v-checkbox", {
        staticClass: "mt-4 new-monitoring-point__copy-share",
        attrs: {
          label: _vm.$t("field.copy_share_label"),
          "data-testid": "new-monitoring-point-copy-share",
        },
        model: {
          value: _vm.copyShare,
          callback: function ($$v) {
            _vm.copyShare = $$v
          },
          expression: "copyShare",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }